import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const DandruffPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Dandruff</h1>
        <section className="mb-8">
          <p>Dandruff is a common scalp condition characterized by flaking and itching. It can be caused by dry skin, oily skin, or fungal infections. Natural therapies can help soothe the scalp, reduce flaking, and promote healthy hair growth.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Dry skin</li>
            <li>Oily skin (seborrheic dermatitis)</li>
            <li>Fungal infections</li>
            <li>Stress</li>
            <li>Poor diet</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>White or yellow flakes on the scalp</li>
            <li>Itching</li>
            <li>Redness or irritation</li>
            <li>Dry or oily scalp</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use soothing herbs, natural oils, and gentle therapies to balance the scalp, reduce flaking, and promote healthy hair growth. Each plan is tailored to your needs for safe, effective care.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Reduces flaking and itching</li>
            <li>Promotes healthy scalp</li>
            <li>No harsh chemicals</li>
            <li>Personalized, gentle care</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Use gentle, natural shampoos</li>
            <li>Maintain a balanced diet</li>
            <li>Manage stress</li>
            <li>Regular scalp care</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment cure dandruff?</strong>
            <p>A: Yes, our approach can significantly reduce symptoms and improve scalp health.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this safe for sensitive skin?</strong>
            <p>A: Yes, our remedies are gentle and soothing.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I see improvement?</strong>
            <p>A: Many patients notice relief within a few weeks.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Say goodbye to dandruff—book your natural scalp care session today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default DandruffPage; 